import {
    OBJECT_TYPE_RECTANGLE_TABLE,
    OBJECT_TYPE_ROUND_TABLE,
    OBJECT_TYPE_SECTOR,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import getSeatingMapObjectLabel from '%paysera_seat_selection/js/seatSelection/services/getSeatingMapObjectLabel';
import getObjectParentChainUpToHall from '%paysera_seat_selection/js/seatSelection/services/getObjectParentChainUpToHall';

const getLabelText = model => `${getSeatingMapObjectLabel(model).text}`;

function createAggregator(aggregate) {
    return (inserted, modelArray, model) => {
        const duplicates = modelArray.filter(comparedModel => getLabelText(model) === getLabelText(comparedModel));

        if (duplicates.length > 1 && !inserted.includes(getLabelText(model))) {
            const result = getObjectParentChainUpToHall(model);
            const [, ...parents] = result;
            aggregate.push([...parents, model]);
            inserted.push(getLabelText(model));
        }
    };
}

function getDuplicateLabelPaths(models) {
    const aggregatedDuplicates = [];
    const aggregate = createAggregator(aggregatedDuplicates);

    models.forEach((modelArray) => {
        const inserted = [];
        modelArray.forEach((model) => {
            aggregate(inserted, modelArray, model);

            if (model.objectType === OBJECT_TYPE_SECTOR) {
                const rowModelArray = model.rows.toModelArray();
                const insertedRows = [];
                rowModelArray.forEach((row) => {
                    aggregate(insertedRows, rowModelArray, row);

                    const insertedRowSeats = [];
                    const seatModelArray = row.seats.toModelArray();
                    seatModelArray.forEach(seat => aggregate(insertedRowSeats, seatModelArray, seat));
                });
            }

            if ([OBJECT_TYPE_RECTANGLE_TABLE, OBJECT_TYPE_ROUND_TABLE].includes(model.objectType)) {
                const insertedTableSeats = [];
                const seatModelArray = model.seats.toModelArray();
                seatModelArray.forEach(seat => aggregate(insertedTableSeats, seatModelArray, seat));
            }
        });
    });

    return aggregatedDuplicates;
}

export default getDuplicateLabelPaths;
